import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import OperationDetailsTable from './OperationDetailsTable';

const OperationDetailsDataTab: FC = () => {
  const { data, actions } = useOperationDetailsPage();

  return (
    <div>
      <OperationDetailsTable />

      {data.isIndependentOperation && !data.isOldOperation && (
        <TablePagination
          totalRows={data.totalPartners || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default OperationDetailsDataTab;
